import { CheckMarkIcon } from '@braskai/icons';
import { Typography, useDeviceType } from '@braskai/ui-kit';

import { Divider, Stack } from '@mui/material';

import { TranslationKey, useInterfaceLanguage } from '@/shared/i18n';

// Figma: background/badge/blue-disabled.
const BANNER_BACKGROUND = '#f0f4fe';

const ADVANTAGES: TranslationKey[] = [
  'pricing.yearly.keepMinutes',
  'pricing.yearly.buyMinutes',
  'pricing.yearly.unlimitedEditing',
];

export const YearlyAdvantages = () => {
  const { isMobile } = useDeviceType();
  const { t } = useInterfaceLanguage();

  return (
    <Stack
      sx={{
        backgroundColor: BANNER_BACKGROUND,
        border: '1px solid',
        borderColor: 'grey.200',
        borderRadius: 16,
        paddingX: 16,
        paddingY: 24,
        width: '100%',
      }}
      alignItems={isMobile ? 'stretch' : 'center'}
      gap={16}
    >
      <Typography color="primary.700" variant="body-2-md">
        {t('pricing.yearly.only')}
      </Typography>
      <Stack
        divider={
          isMobile ? undefined : (
            <Divider
              orientation="vertical"
              sx={{ alignSelf: 'center', borderColor: 'grey.300', height: 24 }}
              flexItem
            />
          )
        }
        alignItems={isMobile ? 'flex-start' : 'center'}
        direction={isMobile ? 'column' : 'row'}
        gap={isMobile ? 8 : 32}
        justifyContent="center"
      >
        {ADVANTAGES.map((advantageKey) => (
          <Stack key={advantageKey} alignItems="center" direction="row" gap={8} sx={{ color: 'primary.700' }}>
            <CheckMarkIcon height={20} width={20} />
            <Typography color="primary.700" variant="body-2-md">
              {t(advantageKey)}
            </Typography>
          </Stack>
        ))}
      </Stack>
    </Stack>
  );
};
